export default __webpack_public_path__ + "static/media/dose.7e5168e9.npy";